import React from 'react'
import { isEmpty } from 'lodash'
import { Col } from 'reactstrap'
import ApiService from '../../../data/services/ApiService'
import { getUrlOfDefaultProductImage } from '../../../helpers/utils'

const routeSuppliersStorage = 'suppliers/'

const Supplier = ({
  logoUrl
}) => {
  return (
    <React.Fragment>
      <div className="cart-supplier-card">
        <Col
          className="text-left cart-card-font"
          style={{ alignSelf: 'center' }}
        >
          Proveedor
        </Col>
        <Col
          className="text-right"
          style={{ alignSelf: 'center' }}
        >
          <img
            src={
              !isEmpty(logoUrl) ?
                `${ApiService.getUrlBaseStorage()}${routeSuppliersStorage}${logoUrl}` 
                : getUrlOfDefaultProductImage()
            }
            alt=""
            width="70px"
            height="50px"
            className="img-fluid mx-auto"
          />
        </Col>
      </div>
    </React.Fragment>
  )
}

export default Supplier
